import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAddNewTaskBaseActionMutation } from "../taskBasesApiSlice"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave, faArrowAltCircleRight } from "@fortawesome/free-solid-svg-icons"
import { useParams } from 'react-router-dom'
import { ACTION_TYPES } from "../../../config/types"
import Uploader from "../../../partial/Uploader"
import Addition from "./Addition"

const _NewActionForm = () => {
    const {taskBaseId, groupId, type:urlType} = useParams()

    const [addNewAction, {
        isLoading,
        isSuccess,
        isError,
        error
    }] = useAddNewTaskBaseActionMutation()

    const navigate = useNavigate()

    const [img, setImg] = useState('')
    const [title, setTitle] = useState('')
    const [text, setText] = useState('')
    const [booleans, setBooleans] = useState('')
    const [type, setType] = useState(ACTION_TYPES[0])
    const [active, setActive] = useState(true)
    const [order, setOrder] = useState(0)
    const [additions, setAdditions] = useState([])
    const [num, setNum] = useState(1)
    const [language, setLanguage] = useState("javascript")
    const [highlight, setHighlight] = useState(true)
    const [ratio, setRatio] = useState(0)

    useEffect(() => {
        if (isSuccess) {
            setImg('')
            setText('')
            setTitle('')
            setType(ACTION_TYPES[0])
            setActive(true)
            navigate(`/${urlType}/${groupId}/task-bases/${taskBaseId}`)
        }
    }, [isSuccess,taskBaseId, navigate])

     const canSave = [ title, type].every(Boolean) && !isLoading

    const onSaveActionClicked = async (e) => {
        e.preventDefault()
        if (canSave) {
            await addNewAction({ taskBaseId,  title, text, img, type, active,order, additions, booleans, highlight, language,ratio })
        }
    }

    const options = ACTION_TYPES.map(type => {
        return (
            <option
                key={type}
                value={type}
            > {type}</option >
        )
    })
    const changeAddition = (id,newAddition) =>{
        if(id===-1) {
            const newObj = {...newAddition, _id:num, required:true}
            setNum(num+1)
            setAdditions([...additions, newObj])
        }
        else{
            if(newAddition) //update
            {
                const additionsList = additions.map((addition, inx)=>{
                    return  addition._id ===id ? newAddition : addition
                })
                setAdditions(additionsList)
            }
            else { //delete
                setAdditions(additions.filter((addition) => addition._id!==id))
            }
        }
    }
    const errClass = isError ? "errmsg" : "offscreen"
  
    const content = (
        <>
            <p className={errClass}>{error?.data?.message}</p>

            <form className="form" onSubmit={onSaveActionClicked}>
                <div className="form__title-row">
                    <h2>New Action</h2>
                    <div className="form__action-buttons">
                        <button
                            className="icon-button"
                            title="Save"
                            disabled={!canSave}
                        >
                            <FontAwesomeIcon icon={faSave} />
                        </button>
                        <button
                            className="icon-button"
                            title="Back"
                            onClick={()=>{navigate(`/${urlType}/${groupId}/task-bases/${taskBaseId}`)}}
                        >
                            <FontAwesomeIcon icon={faArrowAltCircleRight} />
                        </button>
                    </div>
                </div>
                <label className="form__label" htmlFor="action-title">
                    Short title</label>
                <input type="text" id="action-title" 
                value={title} onChange={(e)=>setTitle(e.target.value)}
                className={`form__input ${!title && 'form__input--incomplete'}` }
                maxLength={20}
                 />
                <label className="form__label" htmlFor="action-text">
                    Text:</label>
                <textarea
                    className={`form__input form__input--text`}
                    id="action-text"
                    name="text"
                    value={text}
                    onChange={(e)=>setText(e.target.value)}
                />
                <Uploader label={'Img'} folderId={'MANAGE_ACTIONS'} file={img} setFile={setImg} isImg={true} />


                 <div className="form-flex">
               
                <div  className="form-input-container">
                <label className="form__label form__checkbox-container" htmlFor="action-type">
                            TYPE:</label>
                        <select
                            id="action-type"
                            name="type"
                            className={`form__input`}

                            value={type}
                            onChange={(e)=>setType(e.target.value)}
                        >
                            {options}
                        </select>
                </div>
                <div className="form__row">
                    <div className="form__divider">
                        <label  className="form__label form__checkbox-container" htmlFor={`action-highlight-main`}>
                           Highlight:
                            <input
                                disabled={type!=="Code"}
                                className="form__checkbox"
                                id={`action-highlight-main`}
                                name="highlight"
                                type="checkbox"
                                checked={highlight}
                                onChange={(e)=>setHighlight( prev => !prev)}
                            />
                        </label>
{highlight && <select name="language" disabled={type!=="Code"}  id={`action-language-main`} value={language} onChange={(e)=>setLanguage(e.target.value)}>
                            <option ></option>
                                <option value={"javascript"} >JS</option>
                                <option value={"html"} >HTML</option>
                                <option value={"css"} >CSS</option>
                           </select>
}

                        
                    </div>                   
                </div>
                <div  className="form-input-container">

                    <label className="form__label" htmlFor="action-order">
                    Order:</label>
                    <input
                    className={`form__input `}
                    id="action-order"
                    name="order"
                    type="number"
                    autoComplete="off"
                    value={order}
                    onChange={(e)=>setOrder(e.target.value)}
                    />
                    </div >

                    <div className="form-input-container">
                  <label className="form__label" htmlFor="action-ratio">
                  Ratio:</label>
                <input
                    className={`form__input `}
                    id="action-ratio"
                    name="ratio"
                    type="number"
                    autoComplete="off"
                    value={ratio}
                    onChange={(e)=>setRatio(e.target.value)}
                />
                </div>
                </div>

                {(type==="Code" || type=="Text") && <button type="button" className="bg-white p-2 rounded"   onClick={()=>changeAddition(-1,{})}>+</button>}
{additions.map((addition,inx)=><Addition key={addition._id} id={addition._id} addition={addition}  changeAddition={changeAddition} />) }


<label className="form__label" htmlFor="action-booleans">
                    Booleans: (each value in new line) </label>
                <textarea
                    className={`form__input form__input--text`}
                    id="action-booleans"
                    name="text"
                    value={booleans}
                    onChange={(e)=>setBooleans(e.target.value)}
                />
                <div className="form__row">
                    <div className="form__divider">
                        <label className="form__label form__checkbox-container" htmlFor="action-active">
                           ACTIVE:
                            <input
                                className="form__checkbox"
                                id="action-active"
                                name="active"
                                type="checkbox"
                                checked={active}
                                onChange={(e)=>setActive( prev => !prev)}
                            />
                        </label>

                        
                    </div>                   
                </div>
            </form>
        </>
    )

    return content
}

export default _NewActionForm